/* KICX custom homepage JS — ported from approved Stage 1 mockup. Namespaced; real Shopify cart wiring. */
(function () {
  const root = document.querySelector('.kicx-home');
  if (!root) return;

  // Scroll reveal
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  root.querySelectorAll('.reveal').forEach(el => io.observe(el));

  // Failsafe: reveal anything already in (or near) the viewport — covers anchor-link arrivals and fast jumps
  const kxRevealInView = () => {
    root.querySelectorAll('.reveal:not(.visible)').forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('visible');
    });
  };
  window.addEventListener('load', () => setTimeout(kxRevealInView, 400));
  window.addEventListener('hashchange', () => setTimeout(kxRevealInView, 700));
  if ('onscrollend' in window) window.addEventListener('scrollend', kxRevealInView);

  // Hero parallax (image oversized 118% so the drift never exposes an edge)
  const heroImg = root.querySelector('#kxHeroImg');
  if (heroImg) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY, max = heroImg.parentElement.offsetHeight * 0.08;
      if (y < window.innerHeight) heroImg.style.transform = `translateY(${Math.min(y * 0.07, max)}px)`;
    }, { passive: true });
  }

  // Count-up stats (lands exactly on target)
  const counterIO = new IntersectionObserver(es => {
    es.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target, target = +el.dataset.count, dur = 1400, t0 = performance.now();
      (function tick(t) {
        const p = Math.min((t - t0) / dur, 1);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick); else el.textContent = target;
      })(t0);
      setTimeout(() => { el.textContent = target; }, dur + 200);
      counterIO.unobserve(el);
    });
  }, { threshold: 0.6 });
  root.querySelectorAll('[data-count]').forEach(el => counterIO.observe(el));

  // Flavour switcher — swaps image and points the card's Add button at the right variant
  root.querySelectorAll('.flav[data-variant]').forEach(btn => {
    btn.addEventListener('click', () => {
      const card = btn.closest('.pcard, .her-txt');
      btn.parentElement.querySelectorAll('.flav').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const imgId = btn.dataset.imgTarget;
      const img = imgId ? root.querySelector('#' + imgId) : null;
      if (img && btn.dataset.img) {
        img.style.opacity = 0;
        setTimeout(() => { img.src = btn.dataset.img; img.style.transition = 'opacity .4s'; img.style.opacity = 1; }, 200);
      }
      if (card) {
        const add = card.querySelector('.add-btn[data-add], .btn[data-add]');
        if (add) add.dataset.add = btn.dataset.variant;
      }
    });
  });

  // FAQ accordion
  root.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.parentElement, wasOpen = item.classList.contains('open');
      root.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

  // Sticky add-to-cart bar
  const shopSec = root.querySelector('#kx-shop'), atc = root.querySelector('#kxStickyAtc'), capture = root.querySelector('.capture');
  if (shopSec && atc && capture) {
    window.addEventListener('scroll', () => {
      const pastShop = shopSec.getBoundingClientRect().bottom < 0;
      const nearEnd = capture.getBoundingClientRect().top < window.innerHeight;
      atc.classList.toggle('show', pastShop && !nearEnd);
    }, { passive: true });
  }

  // Add to cart — real Shopify cart + theme drawer. Single listener, in-flight guard (audit #1).
  root.querySelectorAll('[data-add]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const id = parseInt(btn.dataset.add, 10);
      if (!id || btn.disabled) return;
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try {
        const res = await fetch((window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        });
        if (!res.ok) throw new Error('add failed');
        btn.classList.add('kx-added');
        btn.innerHTML = '<svg class="kx-tick" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5l5 5L20 6.8"/></svg>Added';
        if (typeof window.refreshCart === 'function') {
          window.refreshCart(true);
        } else {
          window.location.href = '/cart';
        }
      } catch (err) {
        btn.textContent = 'Try again';
        console.error('KICX add-to-cart:', err);
      } finally {
        setTimeout(() => { btn.textContent = original; btn.classList.remove('kx-added'); btn.disabled = false; }, 2000);
      }
    });
  });
})();
